import { createFileRoute } from "@tanstack/react-router";
import { OperatorScreen, type OperatorSearch } from "../screens/staff/OperatorScreen.tsx";

/**
 * `/sysadmin/runs`: find a company, ask its administrators for access to its run logs, and see where each request stands.
 * The asking is an action; the answer comes from the company's own administrators, and a request nobody answers
 * lapses after 24 hours.
 */
export const Route = createFileRoute("/_staff/sysadmin/runs/")({
  validateSearch: (search: Record<string, unknown>): OperatorSearch =>
    typeof search.q === "string" && search.q.length < 80 && search.q ? { q: search.q } : {},
  component: OperatorScreen,
});
